import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import Survey from 'src/components/survey/survey';
import Modal from 'src/modules/shared/modal/components/modal';
import ResearchModal from './researchModal';
import i18n from 'i18next';
import { trackFootfallEvent } from 'src/utils/analytics';
import footfallEventTypes from 'src/constants/footfallEventTypes';

import { updateNotificationPreference } from 'src/modules/user/shared/actions';
import { closeModal } from 'src/modules/shared/modal/actions';

class ResearchOptIn extends React.Component {
  static propTypes = {
    closeModal: PropTypes.func,
    updateNotificationPreference: PropTypes.func,
    onFinish: PropTypes.func,
  };

  static defaultProps = {
    closeModal: () => {},
    updateNotificationPreference: () => {},
    onFinish: () => {},
  };

  constructor(props) {
    super(props);
    this.state = {
      currentPosition: 0,
      acceptResearch: 'yes',
      currentModalName: 'default',
      showPreferences: false,
    };
  }

  onShowTermsClick = e => {
    e.preventDefault();
    this.setState({ currentModalName: 'terms' });
  };

  onShowPreferences = e => {
    e.preventDefault();
    this.setState({ showPreferences: true });
  };

  getScreens = () => {
    return [
      {
        id: 1,
        key: 'acceptResearch',
        title: i18n.t('One last thing...'),
        content: (
          <div>
            <div>
              <p>
                <strong>
                  {i18n.t('We would like to send you occasional emails about relevant health research you might be eligible for')}
                </strong>
              </p>
              <p>{i18n.t('e.g. surveys, clinical trials, paid market research, beta testing')}</p>
            </div>
            <div className="signup-box__tips">
              <p>
                {i18n.t(
                  'It will always be HealthUnlocked that contacts you. And you can opt out of being contacted at any time.',
                )}
              </p>
              <a href="#" onClick={this.onShowTermsClick}>
                {i18n.t('Learn more')}
              </a>
            </div>
            <div>
              {!this.state.showPreferences ? (
                <a href="#" onClick={this.onShowPreferences}>
                  {i18n.t('Manage preferences')}
                </a>
              ) : (
                <div className="signup-box__form-control">
                  <input
                    checked={this.state.acceptResearch !== 'yes'}
                    type="checkbox"
                    onChange={() =>
                      this.setState({
                        acceptResearch: this.state.acceptResearch === 'yes'
                          ? 'no'
                          : 'yes',
                      })
                    }
                  />
                  <label>{i18n.t('Do not contact me for research purposes (e.g: clinical trial recruitment, survey, etc)')}</label>
                </div>
              )}
            </div>
          </div>
        ),
        buttonText: i18n.t('Ok'),
      },
    ];
  };

  renderScreen = (screen, i) => {
    return (
      <div className="survey__screen survey__screen--no-header signup-box__questions" key={i}>
        <h3 className="signup-box__questions__title">{screen.title}</h3>
        {screen.content}
      </div>
    );
  };

  render() {
    const screens = [...this.getScreens()];

    return (
      <React.Fragment>
        <Modal
          dialogClasses={{
            'app-modal--hidden': this.state.currentModalName !== 'default',
          }}
          noClose={true}
        >
          <Survey
            className="signup-box__survey"
            hideHeader={true}
            progress={90}
            renderScreen={this.renderScreen}
            screens={screens}
            onFinish={() => {
              const { acceptResearch } = this.state;
              if (acceptResearch === 'yes') {
                trackFootfallEvent(footfallEventTypes.CLICKED, {
                  clickType: 'opt-in-research-yes',
                });
              } else {
                trackFootfallEvent(footfallEventTypes.CLICKED, {
                  clickType: 'opt-in-research-no',
                });
              }
              this.props.updateNotificationPreference('HuResearchEmails', acceptResearch === 'yes');
              this.props.closeModal();
              this.props.onFinish({ acceptResearch });
            }}
            onPositionChanged={position => this.setState({ currentPosition: position })}
          />
        </Modal>
        {this.state.currentModalName === 'terms' && (
          <ResearchModal
            isOpen={this.state.currentModalName === 'terms'}
            onClose={() => this.setState({ currentModalName: 'default' })}
          />
        )}
      </React.Fragment>
    );
  }
}

const actions = {
  closeModal,
  updateNotificationPreference,
};

export default connect(null, actions)(ResearchOptIn);



// WEBPACK FOOTER //
// ./src/modules/shared/modal/components/signup/researchOptIn.js